"use client";
import { useState, useEffect } from "react";
import MasterLayout from "../Sections/MasterLayout";
import SuccesModal from "../Sections/SuccesModal";
import Loader from "./Loader";
import {
  server_post_data,
  insert_fare_rule,
  get_fare_rules_by_city,
  // delete_fare_rule, // Add this endpoint for deleting rules
} from "../../ServiceConnection/serviceconnection";
import {
  Download,
  Plus,
  Calculator,
  Gauge,
  Table,
  FileText,
  Tags,
  Route,
  Wallet,
  X,
  Edit,
  Trash2,
  Save,
  Eye,
  RefreshCw,
} from "lucide-react";
import { useNavigate } from "react-router-dom";

const passengers = ["Regular Passenger", "Student", "Senior Citizen"];

export default function FareManagement() {
  const navigate = useNavigate();
  const [selectedLine, setSelectedLine] = useState("Yellow Line");
  const [activeTab, setActiveTab] = useState("Fare Matrix");
  const [showCalculator, setShowCalculator] = useState(false);
  const [showAddSlabModal, setShowAddSlabModal] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [savedRules, setSavedRules] = useState([]);
  const [selectedRule, setSelectedRule] = useState(null);
  const [showRuleDetailsModal, setShowRuleDetailsModal] = useState(false);

  // Fare slabs state
  const [fareSlabs, setFareSlabs] = useState([
    {
      min_distance: 0,
      max_distance: 10,
      base_fare: 10,
      extra_per_km: 0,
    },
    {
      min_distance: 10,
      max_distance: 20,
      base_fare: 20,
      extra_per_km: 0,
    },
  ]);

  // Form state for adding/editing slabs
  const [slabForm, setSlabForm] = useState({
    min_distance: "",
    max_distance: "",
    base_fare: "",
    extra_per_km: "",
  });

  // Calculator state
  const [calculatorDistance, setCalculatorDistance] = useState("");
  const [calculatedFare, setCalculatedFare] = useState(null);

  const tabs = [
    { name: "Fare Matrix", icon: <Table size={18} /> },
    // { name: "Saved Rules", icon: <FileText size={18} /> },
    // { name: "Fare Rules", icon: <FileText size={18} /> },
    // { name: "Categories", icon: <Tags size={18} /> },
  ];

  // Fetch saved rules on component mount
  useEffect(() => {
    getline("4");
  }, []);

  const getline = async (city_id) => {
    setIsLoading(true);
    try {
      const fd = new FormData();
      fd.append("city_id", city_id);
      const response = await server_post_data(get_fare_rules_by_city, fd);
      setSavedRules(response.data.data || []);
      console.log("Slabs:", response.data.data[0].slabs);
      setFareSlabs(response.data.data[0].slabs)
    } catch (error) {
      console.error("Error fetching line data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddSlab = () => {
    if (
      slabForm.min_distance === "" ||
      slabForm.max_distance === "" ||
      slabForm.base_fare === ""
    ) {
      alert("Please fill all required fields");
      return;
    }

    const newSlab = {
      min_distance: Number.parseFloat(slabForm.min_distance),
      max_distance: Number.parseFloat(slabForm.max_distance),
      base_fare: Number.parseFloat(slabForm.base_fare),
      extra_per_km: Number.parseFloat(slabForm.extra_per_km) || 0,
    };

    if (editingIndex !== null) {
      const updatedSlabs = [...fareSlabs];
      updatedSlabs[editingIndex] = newSlab;
      setFareSlabs(updatedSlabs);
      setEditingIndex(null);
    } else {
      setFareSlabs([...fareSlabs, newSlab]);
    }

    setSlabForm({
      min_distance: "",
      max_distance: "",
      base_fare: "",
      extra_per_km: "",
    });
    setShowAddSlabModal(false);
  };

  // console.log("Respo", savedRules)


  const handleEditSlab = (index) => {
    const slab = fareSlabs[index];
    setSlabForm({
      min_distance: slab.min_distance.toString(),
      max_distance: slab.max_distance.toString(),
      base_fare: slab.base_fare.toString(),
      extra_per_km: slab.extra_per_km.toString(),
    });
    setEditingIndex(index);
    setShowAddSlabModal(true);
  };

  const handleDeleteSlab = (index) => {
    if (window.confirm("Are you sure you want to delete this fare slab?")) {
      const updatedSlabs = fareSlabs.filter((_, i) => i !== index);
      setFareSlabs(updatedSlabs);
    }
  };

  const handleDeleteRule = async (ruleId) => {
    if (window.confirm("Are you sure you want to delete this fare rule?")) {
      setIsLoading(true);
      try {
        const fd = new FormData();
        fd.append("rule_id", ruleId);

        // await server_post_data(delete_fare_rule, fd)
        alert("Fare rule deleted successfully!");
        getline("4"); // Refresh the list
      } catch (error) {
        console.error("Failed to delete rule:", error);
        alert("Error deleting rule. Please try again.");
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleViewRuleDetails = (rule) => {
    setSelectedRule(rule);
    setShowRuleDetailsModal(true);
  };

  const calculateFare = () => {
    const distance = Number.parseFloat(calculatorDistance);
    if (!distance || distance <= 0) {
      alert("Please enter a valid distance");
      return;
    }

    // Find the appropriate slab
    const slab = fareSlabs.find(
      (s) => distance >= s.min_distance && distance <= s.max_distance
    );

    if (slab) {
      let fare = slab.base_fare;
      if (slab.extra_per_km > 0 && distance > slab.min_distance) {
        fare += (distance - slab.min_distance) * slab.extra_per_km;
      }
      setCalculatedFare({
        distance: distance,
        fare: fare.toFixed(2),
        slab: slab,
      });
    } else {
      alert("No fare slab found for this distance");
      setCalculatedFare(null);
    }
  };

  const city_id = "4";

  const saveFareRules = async () => {
    setIsLoading(true);
    const fd = new FormData();
    fd.append("rule_name", selectedLine);
    fd.append("rule_id", savedRules[0].rule_id);
    fd.append("city_id", city_id);
    if (fareSlabs.length > 0) {
      fd.append("slabs", JSON.stringify(fareSlabs));
    }

    try {
      await server_post_data(insert_fare_rule, fd);
      setShowSuccessModal(true);
      alert("Fare rules saved successfully!");

      // Clear the slabs after successful save
      setFareSlabs([]);
      setSelectedLine("Blue");

      // Refresh saved rules
      getline("4");

      setTimeout(() => {
        setShowSuccessModal(false);
      }, 2000);
    } catch (error) {
      console.error("Failed to save fare rules:", error);
      alert("Error saving Rule. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <MasterLayout>
      {isLoading && <Loader />}
      <div className="w-full">
        {/* Header */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 w-full flex flex-col justify-between">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 h-full">
            <div>
              <h1 className="text-2xl font-bold text-gray-900 mb-0">
                Fare Management
              </h1>
              <p className="text-sm text-gray-600 mt-1 mb-0">
                Manage distance-based fare rules and pricing slabs
              </p>
            </div>
            <div className="flex items-center gap-2">
              <button
                onClick={() => setShowCalculator(true)}
                className="flex items-center justify-center gap-2 px-4 py-2 btn-secoundary rounded-md transition duration-200"
              >
                <Calculator className="h-5 w-5" />
                Fare Calculator
              </button>
              <button
                onClick={()=>{getline("4")}}
                className="flex items-center justify-center gap-2 px-4 py-2 btn-secoundary rounded-md transition duration-200"
              >
                <RefreshCw className="h-5 w-5" />
                Refresh
              </button>
              {/* <button className="flex items-center justify-center gap-2 px-4 py-2 btn-secoundary rounded-md transition duration-200">
                <Download className="h-5 w-5" />
                Export Fares
              </button> */}
              <button
                onClick={saveFareRules}
                className="flex items-center justify-center gap-2 px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition duration-200"
              >
                <Save className="h-5 w-5" />
                Save Rules
              </button>
            </div>
          </div>
        </div>

        {/* Fare Stat Cards */}
        <div className="mt-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
          <div className="flex flex-col items-center bg-blue-50 border border-blue-200 p-4 rounded-lg">
            <Wallet className="h-5 w-5 text-blue-600" />
            <div className="text-2xl font-bold text-blue-700">
              {fareSlabs.length}
            </div>
            <div className="text-sm text-blue-600">Total Slabs</div>
          </div>
          <div className="flex flex-col items-center bg-purple-50 border border-purple-200 p-4 rounded-lg">
            <Route className="h-5 w-5 text-purple-600" />
            <div className="text-2xl font-bold text-purple-700">
              {fareSlabs.length > 0
                ? Math.max(...fareSlabs.map((s) => s.max_distance))
                : 0}{" "}
              km
            </div>
            <div className="text-sm text-purple-600">Max Distance</div>
          </div>
          <div className="flex flex-col items-center bg-green-50 border border-green-200 p-4 rounded-lg">
            <Gauge className="h-5 w-5 text-green-600" />
            <div className="text-2xl font-bold text-green-700">
              ₹
              {fareSlabs.length > 0
                ? Math.min(...fareSlabs.map((s) => s.base_fare))
                : 0}
            </div>
            <div className="text-sm text-green-600">Min Base Fare</div>
          </div>
          <div className="flex flex-col items-center bg-orange-50 border border-orange-200 p-4 rounded-lg">
            <Wallet className="h-5 w-5 text-orange-600" />
            <div className="text-2xl font-bold text-orange-700">
              ₹
              {fareSlabs.length > 0
                ? Math.max(...fareSlabs.map((s) => s.base_fare))
                : 0}
            </div>
            <div className="text-sm text-orange-600">Max Base Fare</div>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className="mt-4 w-full space-y-4">
        <div className="bg-white rounded-lg border shadow-sm min-h-[300px]">
          <div className="flex border-b border-gray-200">
            {tabs.map((tab) => (
              <button
                key={tab.name}
                onClick={() => setActiveTab(tab.name)}
                className={`flex-1 px-4 py-3 text-sm font-medium border-b-2 transition-colors ${
                  activeTab === tab.name
                    ? "border-blue-500 text-[var(--primary-color)] bg-blue-50"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:bg-gray-50"
                }`}
              >
                <div className="flex items-center justify-center gap-2">
                  {tab.icon}
                  {tab.name}
                </div>
              </button>
            ))}
          </div>

          {/* Tab: Fare Matrix */}
          {activeTab === "Fare Matrix" && (
            <div className="p-6">
              <div className="flex items-center justify-between mb-6">
                <div className="flex items-center gap-2">
                  <Route className="h-6 w-6 text-[var(--primary-color)]" />
                  <h3 className="text-xl font-semibold text-[var(--black)] mb-1">
                    Distance-Based Fare Slabs
                  </h3>
                </div>
                <div className="flex items-center gap-2">
                  <input
                    type="text"
                    className="h-10 border px-4 py-2 rounded-md bg-background text-sm"
                    value={selectedLine}
                    onChange={(e) => setSelectedLine(e.target.value)}
                    placeholder="Enter line name"
                  />
                  <button
                    onClick={() => setShowAddSlabModal(true)}
                    className="flex items-center gap-2 bg-[var(--primary-color)] text-white px-4 py-2 rounded-md hover:bg-blue-700"
                  >
                    <Plus className="h-4 w-4" />
                    Add Slab
                  </button>
                </div>
              </div>

              <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                <div className="overflow-x-auto">
                  <table className="w-full">
                    <thead className="bg-gray-50 border-b border-[#e4e7ea]">
                      <tr>
                        <th className="text-left p-4 text-sm font-medium">
                          Min Distance (km)
                        </th>
                        <th className="text-left p-4 text-sm font-medium">
                          Max Distance (km)
                        </th>
                        <th className="text-left p-4 text-sm font-medium">
                          Base Fare (₹)
                        </th>
                        <th className="text-left p-4 text-sm font-medium">
                          Extra per km (₹)
                        </th>
                        <th className="text-right p-4 text-sm font-medium">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                      {fareSlabs.length === 0 ? (
                        <tr>
                          <td
                            colSpan="5"
                            className="p-8 text-center text-gray-500"
                          >
                            No fare slabs added yet. Click "Add Slab" to get
                            started.
                          </td>
                        </tr>
                      ) : (
                        fareSlabs.map((slab, index) => (
                          <tr key={index}>
                            <td className="p-4 text-sm">{slab.min_distance}</td>
                            <td className="p-4 text-sm">{slab.max_distance}</td>
                            <td className="p-4 text-sm">₹{slab.base_fare}</td>
                            <td className="p-4 text-sm">
                              ₹{slab.extra_per_km}
                            </td>
                            <td className="p-4 text-sm text-right">
                              <div className="flex items-center justify-end gap-2">
                                <button
                                  onClick={() => handleEditSlab(index)}
                                  className="text-blue-600 hover:text-blue-800 p-1"
                                >
                                  <Edit className="h-4 w-4" />
                                </button>
                                <button
                                  onClick={() => handleDeleteSlab(index)}
                                  className="text-red-600 hover:text-red-800 p-1"
                                >
                                  <Trash2 className="h-4 w-4" />
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}

          {/* Tab: Saved Rules */}
          {activeTab === "Saved Rules" && (
            <div className="p-6">
              <div className="flex items-center justify-between mb-6">
                <div className="flex items-center gap-2">
                  <FileText className="h-6 w-6 text-[var(--primary-color)]" />
                  <h3 className="text-xl font-semibold text-[var(--black)] mb-1">
                    Saved Fare Rules
                  </h3>
                </div>
                <button
                  onClick={()=>{getline("4")}}
                  className="flex items-center gap-2 bg-[var(--primary-color)] text-white px-4 py-2 rounded-md hover:bg-blue-700"
                >
                  <RefreshCw className="h-4 w-4" />
                  Refresh
                </button>
              </div>

              {/* Saved Rules Table */}
              <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                <div className="overflow-x-auto">
                  <table className="w-full">
                    <thead className="bg-gray-50 border-b border-[#e4e7ea]">
                      <tr>
                        <th className="text-left p-4 text-sm font-medium">
                          Rule Name
                        </th>
                        <th className="text-left p-4 text-sm font-medium">
                          Total Slabs
                        </th>
                        <th className="text-left p-4 text-sm font-medium">
                          Date Created
                        </th>
                        <th className="text-left p-4 text-sm font-medium">
                          Status
                        </th>
                        <th className="text-right p-4 text-sm font-medium">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                      {savedRules.length === 0 ? (
                        <tr>
                          <td
                            colSpan="5"
                            className="p-8 text-center text-gray-500"
                          >
                            No saved fare rules found.
                          </td>
                        </tr>
                      ) : (
                        savedRules.map((rule, index) => (
                          <tr key={rule.id || index}>
                            <td className="p-4 text-sm font-medium">
                              {rule.rule_name}
                            </td>
                            <td className="p-4 text-sm">
                              {rule.slabs ? JSON.parse(rule.slabs).length : 0}
                            </td>
                            <td className="p-4 text-sm">
                              {rule.created_at
                                ? new Date(rule.created_at).toLocaleDateString()
                                : "N/A"}
                            </td>
                            <td className="p-4 text-sm">
                              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                                Active
                              </span>
                            </td>
                            <td className="p-4 text-sm text-right">
                              <div className="flex items-center justify-end gap-2">
                                <button
                                  onClick={() => handleViewRuleDetails(rule)}
                                  className="text-blue-600 hover:text-blue-800 p-1"
                                  title="View Details"
                                >
                                  <Eye className="h-4 w-4" />
                                </button>
                                <button
                                  onClick={() => handleDeleteRule(rule.id)}
                                  className="text-red-600 hover:text-red-800 p-1"
                                  title="Delete Rule"
                                >
                                  <Trash2 className="h-4 w-4" />
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}

          {/* Tab: Fare Rules */}
          {activeTab === "Fare Rules" && (
            <div className="p-8 text-center">
              <FileText className="h-12 w-12 text-[var(--grey-text)] mx-auto mb-4" />
              <h2 className="text-xl font-semibold text-[var(--black)] mb-2">
                Fare Rules Configuration
              </h2>
              <p className="text-[var(--grey-text)] mb-4">
                Configure additional fare rules and policies.
              </p>
              <button className="flex items-center gap-2 bg-[var(--primary-color)] text-white px-4 py-2 rounded-lg hover:bg-blue-700 mx-auto">
                <Plus className="h-4 w-4" />
                Add Fare Rule
              </button>
            </div>
          )}

          {/* Tab: Categories */}
          {activeTab === "Categories" && (
            <div className="p-8 text-center">
              <Tags className="h-12 w-12 text-[var(--grey-text)] mx-auto mb-4" />
              <h2 className="text-xl font-semibold text-[var(--black)] mb-2">
                Passenger Categories
              </h2>
              <p className="text-[var(--grey-text)] mb-4">
                Manage different passenger categories and their discounts.
              </p>
              <button className="flex items-center gap-2 bg-[var(--primary-color)] text-white px-4 py-2 rounded-lg hover:bg-[var(--primary-hover)] mx-auto">
                <Plus className="h-4 w-4" />
                Add Category
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Add/Edit Slab Modal */}
      {showAddSlabModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center">
          <div className="bg-white w-full max-w-md p-6 rounded-lg shadow-lg relative">
            <button
              className="absolute top-3 right-4 text-gray-500 hover:text-gray-800"
              onClick={() => {
                setShowAddSlabModal(false);
                setEditingIndex(null);
                setSlabForm({
                  min_distance: "",
                  max_distance: "",
                  base_fare: "",
                  extra_per_km: "",
                });
              }}
            >
              <X />
            </button>
            <h2 className="text-xl font-semibold text-[var(--black)] mb-4">
              {editingIndex !== null ? "Edit Fare Slab" : "Add Fare Slab"}
            </h2>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-[var(--black)] mb-2">
                  Min Distance (km) *
                </label>
                <input
                  type="number"
                  className="w-full border p-2 rounded"
                  value={slabForm.min_distance}
                  onChange={(e) =>
                    setSlabForm({ ...slabForm, min_distance: e.target.value })
                  }
                  placeholder="0"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-[var(--black)] mb-2">
                  Max Distance (km) *
                </label>
                <input
                  type="number"
                  className="w-full border p-2 rounded"
                  value={slabForm.max_distance}
                  onChange={(e) =>
                    setSlabForm({ ...slabForm, max_distance: e.target.value })
                  }
                  placeholder="10"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-[var(--black)] mb-2">
                  Base Fare (₹) *
                </label>
                <input
                  type="number"
                  className="w-full border p-2 rounded"
                  value={slabForm.base_fare}
                  onChange={(e) =>
                    setSlabForm({ ...slabForm, base_fare: e.target.value })
                  }
                  placeholder="10"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-[var(--black)] mb-2">
                  Extra per km (₹)
                </label>
                <input
                  type="number"
                  className="w-full border p-2 rounded"
                  value={slabForm.extra_per_km}
                  onChange={(e) =>
                    setSlabForm({ ...slabForm, extra_per_km: e.target.value })
                  }
                  placeholder="0"
                />
              </div>
              <button
                onClick={handleAddSlab}
                className="w-full bg-[var(--primary-color)] text-white px-4 py-2 rounded-md hover:bg-blue-700"
              >
                {editingIndex !== null ? "Update Slab" : "Add Slab"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Rule Details Modal */}
      {showRuleDetailsModal && selectedRule && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center">
          <div className="bg-white w-full max-w-2xl p-6 rounded-lg shadow-lg relative max-h-[80vh] overflow-y-auto">
            <button
              className="absolute top-3 right-4 text-gray-500 hover:text-gray-800"
              onClick={() => {
                setShowRuleDetailsModal(false);
                setSelectedRule(null);
              }}
            >
              <X />
            </button>
            <h2 className="text-xl font-semibold text-[var(--black)] mb-4">
              Fare Rule Details: {selectedRule.rule_name}
            </h2>

            <div className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-600">
                    Rule Name
                  </label>
                  <p className="text-sm font-semibold">
                    {selectedRule.rule_name}
                  </p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-600">
                    Date Created
                  </label>
                  <p className="text-sm">
                    {selectedRule.created_at
                      ? new Date(selectedRule.created_at).toLocaleDateString()
                      : "N/A"}
                  </p>
                </div>
              </div>

              {selectedRule.slabs && (
                <div>
                  <h3 className="text-lg font-semibold mb-3">Fare Slabs</h3>
                  <div className="overflow-x-auto">
                    <table className="w-full border border-gray-200 rounded-lg">
                      <thead className="bg-gray-50">
                        <tr>
                          <th className="text-left p-3 text-sm font-medium">
                            Min Distance (km)
                          </th>
                          <th className="text-left p-3 text-sm font-medium">
                            Max Distance (km)
                          </th>
                          <th className="text-left p-3 text-sm font-medium">
                            Base Fare (₹)
                          </th>
                          <th className="text-left p-3 text-sm font-medium">
                            Extra per km (₹)
                          </th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-200">
                        {JSON.parse(selectedRule.slabs).map((slab, index) => (
                          <tr key={index}>
                            <td className="p-3 text-sm">{slab.min_distance}</td>
                            <td className="p-3 text-sm">{slab.max_distance}</td>
                            <td className="p-3 text-sm">₹{slab.base_fare}</td>
                            <td className="p-3 text-sm">
                              ₹{slab.extra_per_km}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Fare Calculator Modal */}
      {showCalculator && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center">
          <div className="bg-white w-full max-w-md p-6 rounded-lg shadow-lg relative">
            <button
              className="absolute top-3 right-4 text-gray-500 hover:text-gray-800"
              onClick={() => {
                setShowCalculator(false);
                setCalculatorDistance("");
                setCalculatedFare(null);
              }}
            >
              <X />
            </button>
            <h2 className="text-xl font-semibold text-[var(--black)] mb-4">
              Distance-Based Fare Calculator
            </h2>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-[var(--black)] mb-2">
                  Distance (km)
                </label>
                <input
                  type="number"
                  className="w-full border p-2 rounded"
                  value={calculatorDistance}
                  onChange={(e) => setCalculatorDistance(e.target.value)}
                  placeholder="Enter distance in km"
                />
              </div>
              {calculatedFare && (
                <div className="mt-4 border-t pt-4 bg-gray-50 p-4 rounded">
                  <h3 className="font-semibold mb-2">Calculated Fare:</h3>
                  <div className="text-sm space-y-1">
                    <p>Distance: {calculatedFare.distance} km</p>
                    <p>
                      Applicable Slab: {calculatedFare.slab.min_distance} -{" "}
                      {calculatedFare.slab.max_distance} km
                    </p>
                    <p>Base Fare: ₹{calculatedFare.slab.base_fare}</p>
                    <p>Extra per km: ₹{calculatedFare.slab.extra_per_km}</p>
                    <p className="font-bold text-lg text-green-600">
                      Total Fare: ₹{calculatedFare.fare}
                    </p>
                  </div>
                </div>
              )}
              <button
                onClick={calculateFare}
                className="w-full bg-[var(--primary-color)] text-white px-4 py-2 rounded-md hover:bg-blue-700"
                disabled={!calculatorDistance}
              >
                Calculate Fare
              </button>
            </div>
          </div>
        </div>
      )}

      <SuccesModal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        title={"Fare Rule Added Successfully!"}
        subtitle={"Your fare rule has been saved and added to the system."}
        autoClose={false}
      />
    </MasterLayout>
  );
}
